import React, { useContext } from "react";
import { GoogleLogin } from "@react-oauth/google";
import AuthContext from "../../context/AuthContext";
import { message } from "antd";
import { useRequest } from "../../hooks";

export const GoogleLoginButton: React.FC = () => {
  const { googleLoginHandler, handleLoading } = useContext(AuthContext);
  const { handleRequest } = useRequest();

  const handleGoogleLogin = (credentialResponse: any) => {
    handleLoading(true);
    let options: RequestInit = {
      method: "POST",
      body: JSON.stringify({ token: credentialResponse.credential }),
    };
    handleRequest({
      endpoint: "google-auth",
      options,
      onSuccess: (response) => {
        const { data } = response;
        googleLoginHandler(data.token, data.userInfo);
      },
      onError: (e) => {
        handleLoading(false);
        message.error("Google login failed. Please try again.");
      },
    });
  };
  return (
    <GoogleLogin
      onSuccess={handleGoogleLogin}
      onError={() => {
        message.error("Google login failed. Please try again.");
      }}
    />
  );
};
